module.exports = __webpack_public_path__ + "media/images/home/flow_p_1-cd2baa22aa3735523d222ee5cc6c410e.svg";